import { render, staticRenderFns } from "./flat-stepper.component.vue?vue&type=template&id=6a2cd599&scoped=true"
import script from "./flat-stepper.component.vue?vue&type=script&lang=ts"
export * from "./flat-stepper.component.vue?vue&type=script&lang=ts"
import style0 from "./flat-stepper.component.vue?vue&type=style&index=0&id=6a2cd599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2cd599",
  null
  
)

export default component.exports